import React from 'react';
import { Badge } from '../ui/badge';

export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const money = (v, c = 'GBP') => `${c === 'GBP' ? '£' : c + ' '}${Number(v || 0).toFixed(2)}`;
export const hhmm = (iso) => (iso ? iso.slice(11, 16) : '');
export const dayStr = (iso) => (iso ? new Date(iso).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }) : '');
export const sliceLabel = (i) => (i === 0 ? 'Outbound' : 'Inbound');

export const paxLabel = (p, all) => {
  const kind = p.type === 'infant_without_seat' ? 'Infant' : p.type === 'child' ? 'Child' : 'Adult';
  const sameKind = all.filter((x) => x.type === p.type);
  const n = sameKind.findIndex((x) => x.id === p.id) + 1;
  return sameKind.length > 1 ? `${kind} ${n}` : kind;
};

export const conditionText = (c, verb) => {
  if (!c || c.allowed === null || c.allowed === undefined) return { ok: null, label: `${verb} — conditions apply` };
  if (!c.allowed) return { ok: false, label: `Non-${verb.toLowerCase()}able` };
  const fee = c.penalty_amount ? `fee ${money(c.penalty_amount, c.penalty_currency)}` : 'free';
  return { ok: true, label: `${verb}able`, detail: fee };
};

export const CondRow = ({ icon: Icon, ok, label, detail }) => (
  <div className={`flex items-start gap-2 text-sm ${ok === false ? 'text-slate-400' : 'text-slate-700'}`}>
    <Icon className={`h-4 w-4 mt-0.5 ${ok === false ? 'text-slate-300' : 'text-[#FF6600]'}`} />
    <span>{label}{detail ? <span className="text-slate-500"> · {detail}</span> : null}</span>
  </div>
);

export const SliceHeader = ({ slice, label }) => (
  <div className="flex flex-wrap items-center gap-3 mb-3">
    <Badge className="bg-slate-900 text-white">{label}</Badge>
    <div className="font-semibold text-slate-900">{slice.origin} → {slice.destination}</div>
    <div className="text-sm text-slate-600">{dayStr(slice.departing_at)} · {hhmm(slice.departing_at)}–{hhmm(slice.arriving_at)} · {slice.duration} · {slice.stops === 0 ? 'Direct' : `${slice.stops} stop`}</div>
    <div className="text-xs text-slate-500">{slice.flight_numbers.join(', ')}</div>
  </div>
);

export const extrasTotals = (extras, sel) => {
  if (!extras) return { bags: 0, seats: 0, total: 0 };
  const bags = extras.baggage.reduce((acc, b) => acc + (sel.bags[b.id] || 0) * b.amount, 0);
  const seats = Object.values(sel.seats).reduce((acc, perPax) => acc + Object.values(perPax).reduce((a, s) => a + (s?.amount || 0), 0), 0);
  return { bags, seats, total: bags + seats };
};

export const servicesFromSelection = (extras, sel) => {
  if (!extras) return [];
  const out = extras.baggage.filter((b) => sel.bags[b.id] > 0).map((b) => ({
    id: b.id, quantity: sel.bags[b.id], amount: b.amount, type: 'baggage',
    label: `${b.weight_kg ? b.weight_kg + 'kg ' : ''}checked bag${sel.bags[b.id] > 1 ? ` ×${sel.bags[b.id]}` : ''}`,
  }));
  Object.entries(sel.seats).forEach(([segmentId, perPax]) => {
    Object.entries(perPax).forEach(([passengerId, s]) => {
      if (s) out.push({ id: s.id, quantity: 1, amount: s.amount, type: 'seat', label: `Seat ${s.designator}`, segment_id: segmentId, passenger_id: passengerId });
    });
  });
  return out;
};
